module.exports = __webpack_public_path__ + "2449777982f426e64f6b03d7765f9f17.svg";